<div class="flex flex-col justify-center">
  <!-- Error Alert -->
  <div
    *ngIf="loginAttempted && (error | async)"
    class="tix-login-error-placeholder p-4 bg-red-200 rounded-sm mb-2"
  >
    <span class="text-sm font-medium text-red-700">{{ error | async }}</span>
  </div>
  <!-- Login Section -->
  <div class="flex flex-col space-y-4">
    <div class="flex flex-col space-y-2 mb-4">
      <!-- Title -->
      <h4 class="text-2xl text-black font-semibold">Sign in</h4>
      <!-- Subtitle -->
      <p class="text-[#72787E] w-3/4">
        Please fill in the following to sign in to your account, or or
        <a
          class="text-primary underline font-bold hover:text-matprimary-700"
          [routerLink]="REGISTER_ROUTE"
          queryParamsHandling="preserve"
          (click)="onCreateAccountClick($event)"
          >create an account</a
        >.
      </p>
    </div>
    <!-- Form -->
    <form [formGroup]="loginForm" class="flex flex-col tix-auth">
      <!-- Email Input -->
      <mat-form-field hideRequiredMarker="true">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" />
        <mat-error *ngIf="hasError('email', 'required')"
          >Email required</mat-error
        >
        <mat-error *ngIf="hasError('email', 'email')"
          >Invalid email provided</mat-error
        >
      </mat-form-field>

      <!-- Password Input -->
      <mat-form-field hideRequiredMarker="true">
        <mat-label>Password</mat-label>
        <input
          matInput
          [type]="showPassword ? 'text' : 'password'"
          minlength="8"
          maxlength="256"
          formControlName="password"
        />
        <mat-icon
          class="absolute right-2 text-black cursor-pointer"
          (click)="showPassword = !showPassword"
          >{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon
        >

        <mat-hint *ngIf="passwordLength > 128" align="end"
          >{{ passwordLength }}/256</mat-hint
        >
        <mat-error *ngIf="hasError('password', 'required')"
          >Password required</mat-error
        >
        <mat-error *ngIf="hasError('password', 'minlength')"
          >Password must be at least 8 characters ({{
            passwordLength
          }}/8)</mat-error
        >
        <mat-error *ngIf="hasError('password', 'maxlength')"
          >Password must be no more than 256 characters ({{
            passwordLength
          }}/256)</mat-error
        >
      </mat-form-field>

      <!-- Forgot Password Link -->
      <div class="mb-4">
        <a
          class="text-primary text-sm underline hover:text-matprimary-700"
          routerLink="../request-password-reset"
          (click)="onForgotPasswordClick($event)"
          >Forgot password?</a
        >
      </div>

      <!-- Login Button -->
      <button
        matRipple
        class="w-full p-3 flex items-center justify-center rounded-md bg-primary text-white font-medium text-md hover:bg-matprimary-700"
        (click)="login()"
      >
        Login
      </button>
    </form>
    <!-- OR Divider -->
    <div class="my-4 flex items-center gap-4">
      <hr class="w-full border-[#72787E4D]" />
      <p class="text-sm text-[#72787E] text-center">or</p>
      <hr class="w-full border-[#72787E4D]" />
    </div>
    <!-- OAuth Google Button -->
    <button
      matRipple
      aria-label="Google"
      class="w-full p-2.5 flex items-center justify-center rounded-md border-2 border-primary hover:bg-matprimary-50"
      (click)="authWith('google')"
    >
      <tix-icon class="mr-4" svgIcon="google"></tix-icon>
      <span class="font-medium text-md text-primary">Login with Google</span>
    </button>
  </div>
</div>
